import { useWindowDimensions } from './useWindowSize'

const MOBILE_BREAKPOINT = 768

export const useIsMobile = () => {
  const { width } = useWindowDimensions()
  return width < MOBILE_BREAKPOINT
}
